<template>
  <div class="box">
    <div class="search_form">
      <h2 style="text-align:center;">关注万里出行公众号进行购票！</h2>
      <Row>
        <Col span="24" style="margin-top:10px;display:flex;justify-content: center;">
          <img style="width:80%;" src="../assets/20200414153110.jpg" alt="加载失败" />
        </Col>
        <p style="text-align:center;">万里运业官方微信</p>
      </Row>
      <!-- <Row>
        <Col span="24" style="margin-top:20px;display:flex;">
          <div class="add_btn">出发:</div>
          <Select
            label-in-value
            @on-change="start_select"
            filterable
            style="width:82%;"
            placeholder="请选择出发地"
            v-model="falsity"
          >
            <Option
              v-for="(item,id) in cityList"
              :value="item.label"
              :key="id"
            >{{ item.value | endVal_select }}</Option>
          </Select>
        </Col>
        <Col span="24" style="margin-top:20px;display:flex;">
          <div class="add_btn">到达:</div>
          <Select
            filterable
            label-in-value
            placeholder="请输入简拼，如安平:ap"
            @on-change="end_select"
            style="width:82%;"
          >
            <Option
              v-for="(item,id) in endList"
              :value="item.label"
              :key="id"
            >{{ item.value | endVal_select }}</Option>
          </Select>
        </Col>
        <Col span="24" style="margin-top:20px;display:flex;">
          <div class="add_btn">日期:</div>
          <DatePicker
            @on-change="date_onChange"
            :value="date"
            format="yyyy-MM-dd"
            type="date"
            placeholder="请选择日期"
            style="width:82%;"
          ></DatePicker>
        </Col>
        <Col span="24" style="margin-top:20px;">
          <Button type="primary" style="width:100%;" @click="search">查询</Button>
        </Col>
        <Col span="24" style="margin-top:20px;">
          <p>搜素历史：</p>
          <ul class="history_ul">
            <li v-for="(item,index) in history" :key="item.id" @click="history_btn(item)">
              <a>{{item.start.label+"-"+item.end.label}}</a>
            </li>
          </ul>
        </Col>
      </Row> -->
    </div>
  </div>
</template>

<script>
import { getAllStart, getAllStop } from "../api/index.js";
// import Hender from "@/commonality/hender.vue";
// import Footer from "@/commonality/footer.vue";
export default {
  data() {
    return {
      start: "",
      end: "",
      date: "",
      history: [],
      cityList: [],
      endList: [],
      index_obj: {},
      falsity:""
    };
  },
  mounted() {
    return ;
    //初始化输入框信息
    this.getStart();
    this.getend();
    this.date = this.rq();
    this.index_obj.date = this.date;
  },
  filters: {
    //下拉框 过滤器
    endVal_select(val) {
      var reg = /[a-zA-Z]*/g;
      var result = val.replace(reg, "");
      return result;
    }
  },
  methods: {
    date_onChange(date) {
      this.date = date;
      this.index_obj.date = this.date;
    },
    getStart() {
      let msg = {
        backMsgId: "1009002000",
        backSerId: 0,
        key: 0,
        msgBody: {},
        msgId: "1009002001",
        msgSta: 1,
        respType: 0,
        serId: 0,
        source: 0
      };

      getAllStart({ data: msg })
        .then(res => {
          this.cityList = [];

          for (let i = 0; i < res.msgBody.pageOutBody.pageObjBody.length; i++) {
            this.cityList.push({
              value:
                res.msgBody.pageOutBody.pageObjBody[i].fstationName +
                res.msgBody.pageOutBody.pageObjBody[i].fstationPy,
              label:
                res.msgBody.pageOutBody.pageObjBody[i].fstationCode +
                "&" +
                res.msgBody.pageOutBody.pageObjBody[i].fstationPy
            });
            //出发站值固定-！！！！！！！！！！
             this.falsity = "6051&xc  ";
             let obj={
               label: "许昌中心站  ",
               value: "6051&xc  "
             }
             this.index_obj.start = obj;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getend() {
      let msg = {
        backMsgId: "1009002003",
        backSerId: 0,
        key: 0,
        msgBody: {},
        msgId: "1009002002",
        msgSta: 1,
        respType: 0,
        serId: 0,
        source: 0
      };

      getAllStop({ data: msg })
        .then(res => {
          this.endList = [];

          for (let i = 0; i < res.msgBody.pageOutBody.pageObjBody.length; i++) {
            this.endList.push({
              value:
                res.msgBody.pageOutBody.pageObjBody[i].fstationName +
                res.msgBody.pageOutBody.pageObjBody[i].fstationPy,
              label:
                res.msgBody.pageOutBody.pageObjBody[i].fstationCode +
                "&" +
                res.msgBody.pageOutBody.pageObjBody[i].fstationPy
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    rq() {
      var now = new Date();
      var year = now.getFullYear(); //年
      var month = now.getMonth() + 1; //月
      var day = now.getDate(); //日
      var clock = year + "-";
      if (month < 10) clock += "0";
      clock += month + "-";
      if (day < 10) clock += "0";
      clock += day;
      return clock;
    },
    start_select(obj) {
      if (obj == undefined) {
        return false;
      }
      console.log(obj,"=========");
      this.start = obj.label;
      this.index_obj.start = obj;
    },
    end_select(obj) {
      if (obj == undefined) {
        return false;
      }
    console.log(obj,"=========");
      this.end = obj.label;
      this.index_obj.end = obj;
    },
    search() {
      if (this.start == "" && this.end == "") {
        this.$Message.warning("请选择出发地和到达地！");
        return false;
      }

      if (this.date == "") {
        this.$Message.warning("请选择出发日期！");
        return false;
      }

      let txt = this.start + "-" + this.end;
      var his_txt;

      if (this.history.length != 0) {
        his_txt = this.history[0].start.label + "-" + this.history[0].end.label;
      } else {
        his_txt = "-";
      }

      if (this.history.length == 6 && his_txt != txt) {
        this.history.splice(this.history.length - 1, 1);
        let obj = {};
        obj = Object.assign(obj, this.index_obj);
        console.log(obj);
        this.history.unshift(obj);
      } else if (his_txt != txt) {
        let obj = {};
        obj = Object.assign(obj, this.index_obj);
        this.history.unshift(obj);
      }

      this.$router.push({
        path: "/Index/",
        query: {
          obj: JSON.stringify(this.index_obj)
        }
      });
    },
    history_btn(item) {
      this.$router.push({
        path: "/Index",
        query: {
          obj: JSON.stringify(item)
        }
      });
    }
  },
  components: {}
};
</script>

<style scoped>
.box {
  padding: 30px;
  background: #ccc;
  height: 70%;
  background: url("../assets/banner_02.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}
.search_form {
  position: absolute;
  top: 28%;
  right: 16%;
  background: #fff;
  padding: 20px;
  width: 400px;
  border: 1px solid #b6ceea;
}
.add_btn {
  padding: 4px 7px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  background-color: #f8f8f9;
  border: 1px solid #dcdee2;
  border-radius: 4px 0 0 4px;
  display: table-cell;
}
.history_ul {
  list-style: none;
  overflow: hidden;
}
.history_ul li {
  float: left;
  margin: 4px 6px;
}
>>> .ivu-input-with-suffix,
>>> .ivu-select-selection {
  border-radius: 0 4px 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/site_search.vue